import { lang } from '@umu/ukit-lang';
/***
 * @file 勋章升级展示组件
 */

import React from 'react';
import { If } from 'common/src/components';

import { getEncourage, getPrivilege } from '../../util';
import { displayUserLevel, getUserLevelColorScheme } from '../../../../../@utils/userAchievementUtil';

import './userLevel.scss';

interface IProps {
    // data: any;
    userLevel: string;
    onClose: () => void;
}

export default class UserLevel extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public onClose = (evt: React.MouseEvent<HTMLAnchorElement>) => {
        evt.preventDefault();
        evt.stopPropagation();

        this.props.onClose();
    };

    public upgradeLv(userLevel: string) {
        const level = Number(userLevel);
        const encourage = getEncourage(level);
        const privilege = getPrivilege(level);
        const lvText = displayUserLevel(level, true);
        const lvColorScheme = getUserLevelColorScheme(level);
        const cls = `upgrade-lv upgrade-lv-${userLevel} upgrade-lv-range-${lvColorScheme.range}`;

        return (
            <div className={cls} style={{ backgroundColor: lvColorScheme.secondary }}>
                <div className="user-level-dialog-wrap">
                    <div className="lv" style={{ color: lvColorScheme.primary }}>
                        {lvText}
                    </div>
                    <div className="title">{lang('等级提升')}</div>
                    <div className="privilege">
                        <If condition={!!privilege}>
                            <div>
                                <p className="privilege-label" key="label">
                                    {lang('获得奖励')}
                                </p>
                                <p className="privilege-type" key="type">
                                    {privilege}
                                </p>
                            </div>
                        </If>
                    </div>
                    <div className="encourage">{encourage}</div>
                </div>
            </div>
        );
    }

    public render() {
        const { userLevel } = this.props;

        return (
            <div className="user-level-dialog">
                <a className="close" href="#" onClick={this.onClose}></a>
                {this.upgradeLv(userLevel)}
            </div>
        );
    }
}
